import styled, { css } from 'styled-components';
import { Card as AntCard, type CardProps as AntCardProps } from 'antd';
import { type Elevation, getElevation } from '@/components/shared/elevation';
import type { RefObject } from 'react';

export interface CardAntProps
  extends Pick<
    AntCardProps,
    | 'title'
    | 'loading'
    | 'actions'
    | 'extra'
    | 'hoverable'
    | 'bordered'
    | 'children'
    | 'style'
    | 'id'
    | 'className'
    | 'size'
    | 'cover'
    | 'onClick'
    | 'styles'
    | 'variant'
  > {
  $elevation?: Elevation;
  $sameHeight?: boolean;
  ref?: RefObject<HTMLDivElement> | ((instance: HTMLDivElement | null) => void) | null;
}

export const StyledCard = styled(AntCard)<CardAntProps>`
  border-radius: 8px;
  .ant-card-head {
    border-bottom: none;
    margin-bottom: 0;
    ${({ theme }) => {
      return theme.typography.configurations.headline2;
    }}

    &-title {
      padding-bottom: 0px;
    }
  }
  .ant-card-head-wrapper {
    display: flex;
    justify-content: flex-start;
    padding-top: 16px;
  }

  .ant-card-body:empty {
    padding: 8px;
  }

  ${({ title }) =>
    title &&
    css`
      .ant-card-body {
        padding-top: 16px;
      }
    `}

  .ant-card-actions {
    border-top: none;
  }

  ${getElevation}

  // NOTE: if true, the card will be the same height as the parent
  ${({ $sameHeight }) =>
    $sameHeight &&
    css`
      display: flex;
      flex-direction: column;
      height: 100%;

      // NOTE: Sets the height of the card body to 100% so that the action container is at the bottom of the card.
      & .ant-card-body {
        height: 100%;
      }
    `}
`;
